import { Numeric9BoxIcon } from './Numeric9BoxIcon';

/**
 * author: Google
 * id 12DCC44D-8BA2-4D25-A88B-665920C8B730
 * name numeric-9-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number9BoxIcon = Numeric9BoxIcon;
export default Number9BoxIcon